import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAg6AeDwzqJgRXA-NMzy5EXE4IBErNHgx4",
  authDomain: "social-paws-7a982.firebaseapp.com",
  databaseURL: "https://social-paws-7a982-default-rtdb.firebaseio.com",
  projectId: "social-paws-7a982",
  storageBucket: "social-paws-7a982.appspot.com",
  messagingSenderId: "1013145812829",
  appId: "1:1013145812829:web:8d0611e9c4162baab1b2b4",
  measurementId: "G-H6BYPRL9QC",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
